export const headingId = (text: string) =>
  text
    .toLowerCase()
    .replace(/[`*]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
export const headings = (body: string) => {
  let fenced = false;
  return body.split(/\r?\n/).flatMap((line) => {
    if (line.startsWith("```")) fenced = !fenced;
    return !fenced && line.startsWith("## ")
      ? [{ title: line.slice(3), id: headingId(line.slice(3)) }]
      : [];
  });
};
